module.exports = __webpack_public_path__ + "static/img/16bg_6.251c0f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/16bg_6.png
// module id = 662
// module chunks = 1